import React from "react";
import { CircularProgress, Grid } from "@mui/material";

export const PageLoader = () => {
  return (
    <Grid
      container
      direction="column"
      alignContent="center"
      justifyContent="center"
      style={{ height: "100%" }}
      spacing={3}
    >
      <Grid item style={{ textAlign: "center" }}>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};
